import { ElMessage } from "element-plus";

export const broadcast = (res) =>{
  res.status === 10000 ? ElMessage.success(res.msg) : ElMessage.error(res.msg)
}

// 转换时间
export const formatTime = (time) =>{
  //将中国标准时间转化为yyyy-mm-dd h:m:s
  const date = new Date(time);
  var year = date.getFullYear();
  /* 在日期格式中，月份是从0开始的，因此要加0
  * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
  * */
  var month =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1;
  var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  var minutes =
    date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  var seconds =
    date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  // 拼接
  return year + "-" + month + "-" + day + " ";
}

export const initFormData = (form_data,res_data,keyList,otherInit = true) =>{
  if(!keyList){ return }
  Object.keys(form_data).forEach(key =>{
    if(keyList.includes(key)){
      form_data[key] = res_data[key]
    }else{
      otherInit && (form_data[key] = undefined)
    }
  })
}